export const toTitleCase = (value) => {
    if (value) {
        return value.toLowerCase().split(' ').map(function(word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
          }).join(' ');
        
    }
};


